import { CashRegisterXReport, CashMovementType } from "../../types/cash/report";

interface Props {
  data: CashRegisterXReport | null;
}

/**
 * 💰 Sección de movimientos de caja (sin card)
 */
const CashClosingXMovementsSection: React.FC<Props> = ({ data }) => {

  if (!data) {
    return (
      <div className="flex items-center justify-center h-full text-sm text-gray-500 dark:text-gray-400">
        Cargando movimientos...
      </div>
    );
  }

  const format = (value?: number) =>
    (value ?? 0).toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });

  const getLabel = (type: CashMovementType) => {
    switch (type) {
      case CashMovementType.OPENING: return "Apertura";
      case CashMovementType.SALE: return "Ventas";
      case CashMovementType.INCOME: return "Ingresos";
      case CashMovementType.WITHDRAWAL: return "Retiros";
      case CashMovementType.REFUND: return "Devoluciones";
      case CashMovementType.ADJUSTMENT_IN: return "Ajuste (+)";
      case CashMovementType.ADJUSTMENT_OUT: return "Ajuste (-)";
      case CashMovementType.CXP_PAYMENT: return "Pago a Proveedores";
      case CashMovementType.CXC_PAYMENT: return "Cobro a Clientes";
      default: return type;
    }
  };

  const isPositive = (value?: number) => (value ?? 0) >= 0;

  return (
    <div className="h-full flex flex-col">

      {/* 🔹 HEADER */}
      <div className="border-b border-stroke px-5 py-3 dark:border-strokedark">
        <h3 className="text-sm font-medium text-black dark:text-white">
          Movimientos de Caja
        </h3>
      </div>

      {/* 🔹 BODY */}
      <div className="p-5 flex-1 text-sm space-y-4">

        {data.movements && data.movements.length > 0 ? (

          <div className="space-y-2">

            {data.movements.map((m, i) => {

              const positive = isPositive(m.amount);

              return (
                <div
                  key={i}
                  className="
                    flex items-center justify-between
                    rounded-sm px-3 py-2
                    hover:bg-gray-50 dark:hover:bg-white/5
                    transition
                  "
                >

                  {/* LEFT */}
                  <span className="text-gray-600 dark:text-gray-300">
                    {getLabel(m.type)}
                  </span>

                  {/* RIGHT */}
                  <span
                    className={`font-semibold ${
                      positive
                        ? "text-[#3CA745]"
                        : "text-[#DC3545]"
                    }`}
                  >
                    {positive ? "+" : "-"} {format(Math.abs(m.amount ?? 0))}
                  </span>

                </div>
              );
            })}

          </div>

        ) : (

          <div className="text-center text-gray-500 dark:text-gray-400">
            Sin movimientos
          </div>

        )}

        {/* 🔥 TOTAL */}
        <div className="border-t border-dashed border-stroke pt-4 dark:border-strokedark">

          <div className="flex items-center justify-between">

            <span className="text-sm font-medium text-black dark:text-white">
              Efectivo esperado
            </span>

            <span className="text-lg font-bold text-primary">
              {format(data.expectedCash)}
            </span>

          </div>

        </div>

      </div>

    </div>
  );
};

export default CashClosingXMovementsSection;